const channel_campaign_group_kind_options = [
  { label: "Standard", value: "standard" },
  { label: "Top", value: "best_sellers" },
  { label: "Bottom", value: "high_budget" },
  { label: "Neutralna", value: "neutral" },
];

export const getChannelCampaignGroupKind = (val) =>
  channel_campaign_group_kind_options.find(({ value }) => value === val)?.label;

export default channel_campaign_group_kind_options;